export const getFAClientName = () => {
    const accessId = localStorage.getItem("accessId");
    if (!accessId) return null;
  
    const raw = localStorage.getItem("delegateUsers");
    const users = raw && raw !== "undefined" ? JSON.parse(raw || "[]") : [];
  
    if (Array.isArray(users)) {
      const matched = users.find((item) => {
        return (
          (item.id && item.id == accessId) ||
          (item.client && item.client.id == accessId)
        );
      });
  
      return matched && matched.client && matched.client.name || matched && matched.name || "Unknown Client";
    }
  
    return null;
  };
export default getFAClientName  